module.exports = App.PromoCode = DS.Model.extend
  code: DS.attr 'string'
  promo: DS.belongsTo 'promo', async: true
